import { render, staticRenderFns } from "./ExamAttributeCard.vue?vue&type=template&id=46b086af&scoped=true&"
import script from "./ExamAttributeCard.vue?vue&type=script&lang=ts&"
export * from "./ExamAttributeCard.vue?vue&type=script&lang=ts&"
import style0 from "./ExamAttributeCard.vue?vue&type=style&index=0&id=46b086af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b086af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
